import { PageKey } from "@apis:ui_branding/ui_branding";

import { PageDefault, PresetIcon } from "./types";

export const DEFAULT_PRIMARY = "#1fadb2";
export const DEFAULT_SECONDARY = "#156a70";
export const DEFAULT_SIDEBAR = "#AEC5CD";
export const DEFAULT_BACKGROUND = "#EEEDF3";
export const DEFAULT_BROWSER_TITLE = "Nemo";
export const DEFAULT_FAVICON_URL =
  "https://static.wixstatic.com/shapes/ad43e3_a25538a1c4574a14afaab43c6b836cad.svg";

export const DEFAULT_ICON_TYPES: Record<PageKey, "preset" | "custom"> = {
  chat: "preset",
  docs: "preset",
  audio: "preset",
  translation: "preset",
  analytics: "preset",
};

export const PAGE_KEYS: PageKey[] = [
  "chat",
  "docs",
  "audio",
  "translation",
  "analytics",
];

export const PRESET_ICONS: Record<PageKey, PresetIcon[]> = {
  chat: [
    { key: "botNav", label: "Bot" },
    { key: "chatMessageIcon", label: "Chat" },
    { key: "smartToy", label: "Smart Toy" },
    { key: "robot", label: "Robot" },
    { key: "chatBubbles", label: "Bubbles" },
    { key: "messageSquare", label: "Message" },
    { key: "botIcon", label: "Bot Alt" },
    { key: "sendMessage", label: "Send" },
  ],
  docs: [
    { key: "docsNav", label: "Docs" },
    { key: "documentIcon", label: "Document" },
    { key: "writeIcon", label: "Write" },
    { key: "fileLines", label: "File" },
    { key: "fileText", label: "Text" },
    { key: "folderOpen", label: "Folder" },
    { key: "searchIcon", label: "Search" },
    { key: "uploadIcon", label: "Upload" },
  ],
  audio: [
    { key: "audio", label: "Audio" },
    { key: "microphone", label: "Mic" },
    { key: "headphones", label: "Headphones" },
    { key: "voiceOver", label: "Voice" },
    { key: "chatVoice", label: "Chat Voice" },
    { key: "time", label: "Time" },
    { key: "sendMessage", label: "Message" },
    { key: "speakerNotes", label: "Notes" },
  ],
  translation: [
    { key: "docTranslate", label: "Translate" },
    { key: "translate", label: "Translate Alt" },
    { key: "gTranslate", label: "G Translate" },
    { key: "language", label: "Language" },
    { key: "documentIcon", label: "Document" },
    { key: "writeIcon", label: "Write" },
    { key: "fileLines", label: "File" },
    { key: "searchIcon", label: "Search" },
  ],
  analytics: [
    { key: "analyticsNav", label: "Analytics" },
    { key: "pieChart", label: "Pie Chart" },
    { key: "barChart", label: "Bar Chart" },
    { key: "trendingUp", label: "Trending" },
    { key: "insights", label: "Insights" },
    { key: "checkMarkCircle", label: "Check" },
    { key: "analytics", label: "Analytics Alt" },
    { key: "searchIcon", label: "Search" },
  ],
};

export const PAGE_DEFAULTS: Record<PageKey, PageDefault> = {
  docs: {
    tooltip: "Go to nemo docs",
    title: "Nemo Docs",
    description:
      "Hey there, I am Nemo Docs! Upload your file here or simply write any text to explore your data with AI",
  },
  audio: {
    tooltip: "Go to nemo audio",
    title: "Nemo Audio",
    description:
      "Transform your audio and video content into searchable, queryable insights with AI",
  },
  chat: {
    tooltip: "Go to nemo talk",
    title: "How can I help you today?",
    description: "",
  },
  analytics: {
    tooltip: "Go to nemo analytics",
    title: "Bot usage analytics",
    description: "",
  },
  translation: {
    tooltip: "Go to nemo document translation",
    title: "Document Translation",
    description: "Translate your documents to multiple languages",
  },
};
